import React, { useEffect, useState, useRef } from "react";
import ImageWithBasePath from "../imageWithBasePath";
import { header } from "../data/json/header";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../../feature-module/router/all_routes";
import { setDataTheme } from "../../redux/themeSettingSlice";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../hooks/useAuth";
import { role, roleNames } from "../../constants/userConstants";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import Notification from "../notifications/Notifications";
import { useHandleFile } from "../../hooks/useHandleFile";
import { UserFill } from "../icons/icons";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMegaMenu, setIsMegaMenu] = useState(false);
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const [subsidebar2, setSubsidebar2] = useState("");
  const [basePath, setBasePath] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const { logout, moodleUser } = useAuth();
  const { moodleFileSrc } = useHandleFile(moodleUser?.profileimageurl);
  const { t } = useTranslation();
  const menuRef = useRef<HTMLDivElement>(null);

  const handleDataThemeChange = (theme: string) => {
    dispatch(setDataTheme(theme));
  };
  const onHandleMobileMenu = () => {
    // Scroll to top first
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // Wait a bit for scroll to complete, then open menu
    setTimeout(() => {
      const root = document.getElementsByTagName("html")[0];
      root.classList.add("menu-opened");
    }, 650);
  };
  const onhandleCloseMenu = () => {
    const root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };

  // Thêm function để xử lý click ra ngoài menu
  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      onhandleCloseMenu();
    }
  };

  // Thêm function để xử lý click vào item menu
  const handleMenuItemClick = () => {
    onhandleCloseMenu();
  };

  const onHandleLogout = () => {
    logout();
  };

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };
  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const toggleSubsidebar2 = (subitem: any) => {
    if (subitem === subsidebar2) {
      setSubsidebar2("");
    } else {
      setSubsidebar2(subitem);
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    document.documentElement.setAttribute("class", dataTheme);
  }, [dataTheme]);
  useEffect(() => {
    const path = location.pathname;
    const pathArray = path.split("/").filter(Boolean); // Removes empty strings from the split result
    setBasePath(pathArray[0]);
  }, [location.pathname]);
  const DarkButton = () => {
    return (
      <div className={`icon-btn me-2`}>
        <Link
          to="#"
          id="dark-mode-toggle"
          className={`theme-toggle ${dataTheme === "light" && "activate"}`}
          onClick={() => handleDataThemeChange("dark-mode")}
        >
          <i className="isax isax-sun-15" />
        </Link>
        <Link
          to="#"
          id="light-mode-toggle"
          className={`theme-toggle ${dataTheme === "dark-mode" && "activate"}`}
          onClick={() => handleDataThemeChange("light")}
        >
          <i className="isax isax-moon" />
        </Link>
      </div>
    );
  };
  useEffect(() => {
    // Thêm event listener để xử lý click outside
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      {/* Header */}

      <header className={`header-container ${scrolled ? 'fixed' : ''}`}>
        <div className=" container header-nav">
          <div className="navbar-header">
            <Link id="mobile_btn" to="#" onClick={() => onHandleMobileMenu()}>
              <span className="bar-icon">
                <i className="isax isax-menu"></i>
              </span>
            </Link>
            <div className="navbar-logo">
              <Link
                className="logo-white header-logo"
                to={
                  moodleUser?.role?.roleid === role?.student
                    ? all_routes.studentDashboard
                    : all_routes.instructorDashboard
                }
              >
                <ImageWithBasePath
                  src="assets/img/logo_banner_cyber.png"
                  className="logo logo-mobile-mt"
                  alt="Logo"
                  width={65}
                />
              </Link>
              <Link
                className="logo-dark header-logo"
                to={
                  moodleUser?.role?.roleid === role?.student
                    ? all_routes.studentDashboard
                    : all_routes.instructorDashboard
                }
              >
                <ImageWithBasePath
                  src="assets/img/logo_banner_cyber.png"
                  className="logo"
                  alt="Logo"
                  width={70}
                />
              </Link>
            </div>
          </div>
          <div ref={menuRef} className={`main-menu-wrapper ${isMegaMenu ? "active" : ""}`}>
            <div className="menu-header">
              <Link to={all_routes.homeone} className="menu-logo">
                <ImageWithBasePath
                  src="assets/img/logo_banner_cyber.png"
                  className="img-fluid"
                  alt="Logo"
                  width={70}
                />
              </Link>
              <Link
                id="menu_close"
                className="menu-close"
                to="#"
                onClick={() => onhandleCloseMenu()}
              >
                <i className="fas fa-times" />
              </Link>
            </div>
            <ul className={`main-nav ${isMegaMenu ? "active" : ""}`}>
              {moodleUser?.role?.roleid === 5
                ? header.map((mainMenus: any, mainIndex) => (
                    <React.Fragment key={mainIndex}>
                      {mainMenus.separateRoute ? (
                        <li
                          key={mainIndex}
                          className={`has-submenu megamenu ${
                            location.pathname.includes("index") ? "active" : ""
                          }`}
                          onClick={() => toggleSidebar(mainMenus.tittle)}
                          onMouseOver={() => setIsMegaMenu(true)}
                          onMouseLeave={() => setIsMegaMenu(false)}
                        >
                          <Link to="#">
                            {t(`headerMenu.${mainMenus.key}`)}
                            <i
                              className={` ${
                                basePath === "instructor" ||
                                basePath === "student"
                                  ? "isax isax-add"
                                  : "fas fa-chevron-down"
                              }`}
                            />
                          </Link>
                          <ul
                            className={`submenu mega-submenu ${
                              subOpen === mainMenus.tittle ? "d-block" : ""
                            }`}
                            onMouseOver={() => setIsMegaMenu(true)}
                            onMouseLeave={() => setIsMegaMenu(false)}
                          >
                            <li>
                              <div className="megamenu-wrapper">
                                <div className="row">
                                  {mainMenus.menu.map((menu: any, idx: any) => (
                                    <div className="col-lg-2" key={idx}>
                                      <div
                                        className={`single-demo ${
                                          location.pathname === menu.route
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        <div className="demo-img">
                                          <Link
                                            to={menu.route}
                                            className="inner-demo-img"
                                            onClick={handleMenuItemClick}
                                          >
                                            <ImageWithBasePath
                                              src={menu.img}
                                              className="img-fluid "
                                              alt="img"
                                            />
                                          </Link>
                                        </div>
                                        <div className="demo-info">
                                          <Link
                                            to={menu.route}
                                            className="inner-demo-img"
                                            onClick={handleMenuItemClick}
                                          >
                                            {t(`headerMenu.${menu.key}`)}
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </li>
                          </ul>
                        </li>
                      ) : (
                        <li
                          className={`${mainMenus.route ? "" : "has-submenu"} ${
                            mainMenus?.menu?.some((item: any) =>
                              item?.route?.includes(location.pathname)
                            ) ||
                            basePath === mainMenus.base ||
                            basePath === mainMenus.base2 ||
                            location.pathname === mainMenus.route
                              ? "active"
                              : ""
                          }`}
                        >
                          {mainMenus.route ? (
                            <Link to={mainMenus.route} onClick={handleMenuItemClick}>
                              {t(`headerMenu.${mainMenus.key}`)}
                            </Link>
                          ) : (
                            <>
                              <Link
                                to="#"
                                onClick={() => toggleSidebar(mainMenus.tittle)}
                              >
                                {t(`headerMenu.${mainMenus.key}`)}{" "}
                                <i
                                  className={` ${
                                    basePath === "instructor" ||
                                    basePath === "student"
                                      ? "isax isax-add"
                                      : "fas fa-chevron-down"
                                  }`}
                                ></i>
                              </Link>
                              <ul
                                className={`submenu ${
                                  subOpen === mainMenus.tittle ? "d-block" : ""
                                }`}
                              >
                                {mainMenus.menu?.map(
                                  (menu: any, menuIndex: any) => (
                                    <li
                                      key={`${mainIndex}-${menuIndex}`}
                                      className={
                                        location.pathname.includes(
                                          menu.route || ""
                                        )
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <Link to={menu.route} onClick={handleMenuItemClick}>
                                        {t(`headerMenu.${menu.key}`)}
                                      </Link>
                                    </li>
                                  )
                                )}
                              </ul>
                            </>
                          )}
                        </li>
                      )}
                    </React.Fragment>
                  ))
                : header.map((mainMenus: any, mainIndex) => (
                    <React.Fragment key={mainIndex}>
                      {mainMenus.separateRoute ? (
                        <li
                          key={mainIndex}
                          className={`has-submenu megamenu ${
                            location.pathname.includes("index") ? "active" : ""
                          }`}
                          onClick={() => toggleSidebar(mainMenus.tittle)}
                          onMouseOver={() => setIsMegaMenu(true)}
                          onMouseLeave={() => setIsMegaMenu(false)}
                        >
                          <Link to="#">
                            {t(`headerMenu.${mainMenus.key}`)}
                            <i
                              className={` ${
                                basePath === "instructor" ||
                                basePath === "student"
                                  ? "isax isax-add"
                                  : "fas fa-chevron-down"
                              }`}
                            />
                          </Link>
                          <ul
                            className={`submenu mega-submenu ${
                              subOpen === mainMenus.tittle ? "d-block" : ""
                            }`}
                            onMouseOver={() => setIsMegaMenu(true)}
                            onMouseLeave={() => setIsMegaMenu(false)}
                          >
                            <li>
                              <div className="megamenu-wrapper">
                                <div className="row">
                                  {mainMenus.menu.map((menu: any, idx: any) => (
                                    <div className="col-lg-2" key={idx}>
                                      <div
                                        className={`single-demo ${
                                          location.pathname === menu.route
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        <div className="demo-img">
                                          <Link
                                            to={menu.route}
                                            className="inner-demo-img"
                                            onClick={handleMenuItemClick}
                                          >
                                            <ImageWithBasePath
                                              src={menu.img}
                                              className="img-fluid "
                                              alt="img"
                                            />
                                          </Link>
                                        </div>
                                        <div className="demo-info">
                                                                                      <Link
                                              to={menu.route}
                                              className="inner-demo-img"
                                              onClick={handleMenuItemClick}
                                            >
                                              {t(`headerMenu.${menu.key}`)}
                                            </Link>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </li>
                          </ul>
                        </li>
                      ) : (
                        <li
                          className={`${mainMenus.route ? "" : "has-submenu"} ${
                            mainMenus?.menu?.some((item: any) =>
                              item?.route?.includes(location.pathname)
                            ) ||
                            basePath === mainMenus.base ||
                            basePath === mainMenus.base2 ||
                            location.pathname === mainMenus.route
                              ? "active"
                              : ""
                          }`}
                        >
                          {mainMenus.route ? (
                            <Link to={mainMenus.route} onClick={handleMenuItemClick}>
                              {t(`headerMenu.${mainMenus.key}`)}
                            </Link>
                          ) : (
                            <>
                              <Link
                                to="#"
                                onClick={() => toggleSidebar(mainMenus.tittle)}
                              >
                                {t(`headerMenu.${mainMenus.key}`)}{" "}
                                <i
                                  className={` ${
                                    basePath === "instructor" ||
                                    basePath === "student"
                                      ? "isax isax-add"
                                      : "fas fa-chevron-down"
                                  }`}
                                ></i>
                              </Link>
                              <ul
                                className={`submenu ${
                                  subOpen === mainMenus.tittle ? "d-block" : ""
                                }`}
                              >
                                {mainMenus.menu?.map(
                                  (menu: any, menuIndex: any) => (
                                    <li
                                      key={`${mainIndex}-${menuIndex}`}
                                      className={
                                        location.pathname.includes(
                                          menu.route || ""
                                        )
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <Link to={menu.route} onClick={handleMenuItemClick}>
                                        {t(`headerMenu.${mainMenus.key}`)}
                                      </Link>
                                    </li>
                                  )
                                )}
                              </ul>
                            </>
                          )}
                        </li>
                      )}
                    </React.Fragment>
                  ))}
            </ul>
          </div>
          {/* profile menu */}
          <div className="header-btn d-flex align-items-center">
            <Notification />
            <LanguageSwitcher />
            {/* <DarkButton /> */}
            <div className="dropdown profile-dropdown">
              <Link
                to="#"
                className="d-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <span className="avatar">
                  {moodleUser ? (
                    <img
                      src={moodleUser?.profileimageurl}
                      alt="User avatar"
                      className="img-fluid rounded-circle"
                    />
                  ) : (
                    <UserFill />
                  )}
                </span>
              </Link>
              <div className="dropdown-menu dropdown-menu-end min-w-200">
                <div className="profile-header d-flex align-items-center">
                  <div className="avatar">
                    {moodleUser ? (
                      <img
                        src={moodleUser?.profileimageurl}
                        alt="User avatar"
                        className="img-fluid rounded-circle"
                      />
                    ) : (
                      <UserFill />
                    )}
                  </div>
                  <div>
                    <h6>{moodleUser?.fullname}</h6>
                    <p>{t(roleNames[moodleUser?.role?.roleid])}</p>
                  </div>
                </div>
                <ul className="profile-body">
                  <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentProfile}
                    >
                      <i className="isax isax-security-user me-2" />
                      {t("sidebarMenu.profile")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentQuiz}
                    >
                      <i className="isax isax-award me-2" />
                      {t("sidebarMenu.quizAttempts")}
                    </Link>
                  </li>

                  {/* Đây là OrderHistory */}
                  {/* <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium2"
                      to={all_routes.studentOrderHistory}
                    >
                      <i className="isax isax-shopping-cart me-2" />
                      Order History
                    </Link>
                  </li> */}

                  {/* <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentMessage}
                    >
                      <i className="isax isax-messages-3 me-2" />
                      {t("sidebarMenu.messages")}
                      <span className="message-count">2</span>
                    </Link>
                  </li> */}

                  {/* Đây là menu header Wishlist */}
                  {/* Đã xóa vì không cần thiết */}
                  {/* <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentWishlist}
                    >
                      <i className="isax isax-heart me-2" />
                      Wishlist
                    </Link>
                  </li> */}

                  {/* Đây là menu header order history */}
                  {/* Đã xóa vì không cần thiết */}
                  {/* <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentOrderHistory}
                    >
                      <i className="isax isax-shopping-cart me-2" />
                      Order History
                    </Link>
                  </li> */}

                  {/* Đây là menu header referral */}
                  {/* Đã xóa vì không cần thiết */}
                  {/* <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentReferral}
                    >
                      <i className="isax isax-user-add me-2" />
                      Referrals
                    </Link>
                  </li> */}

                  {/* <li>
                    <Link
                      className="dropdown-item d-inline-flex align-items-center rounded fw-medium"
                      to={all_routes.studentSettings}
                    >
                      <i className="isax isax-setting-2 me-2" />
                      {t("sidebar.settings")}
                    </Link>
                  </li> */}
                </ul>
                <div className="profile-footer">
                  <Link
                    to={"#"}
                    onClick={onHandleLogout}
                    className="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
                  >
                    <i className="isax isax-logout me-2" />
                    {t("sidebar.logout")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* /Header */}
    </>
  );
};

export default Header;
